import React, { forwardRef, useMemo, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import { Table } from "../../../../components/ui/Table";
import { useHeaderKeys } from "../../hooks";
import Icon from "../../../../components/Icon";
import { Alert } from "react-bootstrap";
import { PiFileCsvLight } from "react-icons/pi";
import { Tooltip } from "../../../../components/ui/Tooltip";
import { useDownloadCsv, useUploadFileToServer } from "../../hooks";
const StepThree = forwardRef((props, ref) => {
  const {
    selectedHeaders = [],
    newData = [],
    setNewData,
    validData = [],
    invalidData = [],
    summary = null,
    formik,
    fileInformation,
    fieldErrors,
    setFieldErrors,
  } = props;

  const phoneKey = useHeaderKeys(validData);

  let emailKey = null;
  if (formik.values.validEmail) {
    emailKey = useHeaderKeys(validData, "email");
  }
  const { download } = useDownloadCsv(newData, "contacts.csv");
  const { download: downloadErrors } = useDownloadCsv(
    fieldErrors,
    "errors.csv",
  );
  const columns = useMemo(() => {
    const ARRAY = [
      {
        Header: "Teléfono",
        accessor: "msisdn",
      },
      {
        Header: "Otros",
        accessor: "extradata",
      },
    ];

    if (formik.values.validEmail) {
      ARRAY.splice(1, 0, {
        Header: "Correo",
        accessor: emailKey,
      });
    }

    return ARRAY;
  }, []);

  React.useEffect(() => {
    const excluded = new Set([...selectedHeaders, phoneKey]);
    const parsed = validData.map((row) => {
      const other = Object.fromEntries(
        Object.entries(row).filter(([key]) => !excluded.has(key)),
      );

      return {
        msisdn: row[phoneKey],
        extradata: JSON.stringify(other),
      };
    });

    setNewData(parsed);
    setFieldErrors(invalidData);
  }, [validData, selectedHeaders, invalidData]);

  const { mutateAsync: handleUpload } = useUploadFileToServer({
    data: newData,
    fileInformation,
    formik,
  });

  const dataSliced = useMemo(() => {
    return newData.slice(0, 5);
  }, [newData]);

  useImperativeHandle(ref, () => ({
    handleUpload,
  }));

  return (
    <>
      <div className="flex flex-col gap-2">
        <Alert className="Notice">
          <div className="flex gap-2">
            <Icon icon="info" className={"text-blue-500"} />
            <b>Nota:</b> Solo se han cargado los primeros 5 contactos puedes
            descargar el archivo completo en la sección de abajo
          </div>
        </Alert>
        <div className="flex justify-end items-center gap-2">
          <Tooltip message="Exportar a CSV el nuevo archivo generado">
            <button
              onClick={download}
              className="border-none h-[36px] rounded-lg  text-blue-400 hover:bg-blue-400 hover:text-white transition-all ease-out
                    px-3 flex items-center gap-2 text-sm font-medium"
            >
              <PiFileCsvLight size={24} />
            </button>
          </Tooltip>

          {summary?.summary?.invalid > 0 && (
            <Tooltip message="Descargar los contactos con errores">
              <button
                className="group text-sm border-none h-[36px] bg-red-50 text-red-700 font-semibold flex items-center gap-2 rounded-lg px-3 py-1 hover:text-white hover:bg-red-700 transition-all ease-out"
                onClick={downloadErrors}
              >
                <Icon
                  icon="download"
                  className="text-red-700 group-hover:text-white"
                />
                Errores
              </button>
            </Tooltip>
          )}
        </div>
      </div>

      <Table
        data={dataSliced}
        columns={columns}
        config={{
          pagination: true,
          pageSize: 10,
          perPage: 10,
          footer: true,
        }}
      />
    </>
  );
});

StepThree.propTypes = {
  data: PropTypes.array,
  selectedHeaders: PropTypes.array,
  newData: PropTypes.array,
  setNewData: PropTypes.func,
  validData: PropTypes.array,
  invalidData: PropTypes.array,
  summary: PropTypes.object,
  formik: PropTypes.object,
  fileInformation: PropTypes.object,
  fieldErrors: PropTypes.array,
  setFieldErrors: PropTypes.func,
};
export default StepThree;
